<!--
  ~ Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
  -->

<div
  class="main-row"
  *ngIf="isInstaMed() || merchantService.isGlobalPayments(merchant)"
>
  <div class="row mt-4">
    <div class="col-md-12">
      <legend class="row">
        <div class="col-md-6 m-auto" *ngIf="!editable">
          Payment Processor Information
        </div>
        <div class="col-md-6">
          <!--Get the mf-edit-button-->
          <button
            class="btn btn-primary float-right"
            *ngIf="
              isUserBase() && !isWorldPay() && isMerchantActive() && !editable
            "
            (click)="setEditable(true)"
          >
            <span>
              <fa-icon [icon]="faEditPencil"></fa-icon>
            </span>
            Edit Merchant Info
          </button>
        </div>
      </legend>
    </div>
  </div>
  <div *ngIf="!editable">
    <app-payment-processor-info
      [merchant]="merchant"
    ></app-payment-processor-info>
    <div class="col-md-12 removePadding">
      <legend class="row ml-sm-0 mb-3 borderDivide">
        <div class="borderSeparation">General Merchant Info</div>
      </legend>
      <app-general-info [merchant]="merchant"></app-general-info>
    </div>
    <div class="col-md-12 removePadding"></div>
  </div>
  <div class="mt-3" *ngIf="editable">
    <form
      name="generalInfoFormControl"
      class="form-horizontal"
      novalidate
      [formGroup]="merchantDetailsForm"
      (submit)="updateGeneralInfo()"
    >
      <legend class="row ml-sm-0 mb-3">
        <div class="col-md-6 offset-md-3">General Merchant Info</div>
      </legend>
      <app-general-info-edit
        [parentGroup]="merchantDetailsForm"
        [generalInfo]="this.generalInfoFormGroup"
        [isEditable]="editable"
        [merchant]="merchant"
        [hiddenField]="true"
      >
      </app-general-info-edit>
      <app-edit-buttons
        [buttonName]="buttonName"
        [actionInProgress]="actionInProgress"
        [formInvalid]="!isUpdateGeneralInfoValid()"
        (editableEvent)="receiveEditEvent($event)"
      ></app-edit-buttons>
    </form>
  </div>
</div>
